(() => {
  if (window.wmMobileProductLoaded) return;
  window.wmMobileProductLoaded = true;
  const mq = matchMedia('(max-width:767px)');
  const icons = {
    details:'<path d="M6 2h8l4 4v16H6zM14 2v5h4M9 11h6M9 15h6"/>',
    care:'<path d="m2 6 3 15h14l3-15M3 8q3 4 6 0 3 4 6 0 3 4 6 0"/>',
    delivery:'<path d="M1 4h13v12H1zM14 8h4l4 5v3h-8"/><circle cx="5" cy="18" r="2"/><circle cx="18" cy="18" r="2"/>'
  };
  const svg = path => `<svg viewBox="0 0 24 24" aria-hidden="true">${path}</svg>`;
  const start = () => document.querySelectorAll('[data-wm-mobile-product]').forEach(module => {
    if (module.wmReady) return;
    const root = module.closest('.t4s-section-main-product');
    const info = root?.querySelector('.t4s-product__info-container');
    if (!root || !info) return;
    module.wmReady = true;
    const labels = JSON.parse(module.querySelector('[data-wm-labels]').textContent);
    const form = info.querySelector('form.t4s-form__product');
    const originalTitle = info.querySelector('h1');
    const titleText = originalTitle?.textContent.trim();
    const information = module.querySelector('[data-wm-information]');
    const variants = root.querySelector('.pr_variants_json') ? JSON.parse(root.querySelector('.pr_variants_json').textContent) : [JSON.parse(module.querySelector('[data-wm-default-variant]').textContent)];
    let allowInitialAvailabilityFix = true;
    let correctingInitialVariant = false;
    const ensureInitialAvailableVariant = () => {
      if (!allowInitialAvailabilityFix || correctingInitialVariant || !form) return;
      const select = form.querySelector('select[name="id"],select[name="items[][id]"]');
      if (!select) return;
      const current = variants.find(v => String(v.id) === String(select.value));
      if (current?.available) {
        const mismatch = [...info.querySelectorAll('[data-swatch-option]')].some(group =>
          group.querySelector('[data-swatch-item].is--selected')?.dataset.value !== current.options?.[Number(group.dataset.id)]
        );
        const button = form.querySelector('.t4s-product-form__submit');
        if (!mismatch && !button?.disabled && button?.getAttribute('aria-disabled') !== 'true') return;
      }
      const next = current?.available ? current : variants.find(v => v.available);
      if (!next) return;
      correctingInitialVariant = true;
      try {
        select.value = String(next.id);
        select.dispatchEvent(new Event('change',{bubbles:true,cancelable:true}));
      } finally {correctingInitialVariant = false;}
    };
    if (form) {
      const userChoosing = () => {allowInitialAvailabilityFix = false;};
      form.addEventListener('pointerdown',userChoosing);
      form.addEventListener('keydown',userChoosing);
      form.addEventListener('change',ensureInitialAvailableVariant);
      window.addEventListener('pageshow',event => {
        if (event.persisted) {
          allowInitialAvailabilityFix = true;
          requestAnimationFrame(ensureInitialAvailableVariant);
        }
      });
      requestAnimationFrame(ensureInitialAvailableVariant);
    }
    const bank = [];
    const cleanup = [];
    let active = false;
    let raf = 0;
    const relocate = (node, parent) => {
      const anchor = document.createComment('');
      node.before(anchor);
      bank.push([node,anchor]);
      parent.append(node);
    };
    const details = (label, icon, open = false) => {
      const d = document.createElement('details');
      d.open = open;
      const summary = document.createElement('summary');
      summary.innerHTML = svg(icons[icon] || icons.details);
      summary.append(document.createTextNode(label));
      summary.insertAdjacentHTML('beforeend','<svg class="wm-chevron" viewBox="0 0 24 24" aria-hidden="true"><path d="m5 9 7 7 7-7"/></svg>');
      const body = document.createElement('div');
      body.className = 'wm-mobile-detail-body t4s-rte';
      d.append(summary,body);
      information.append(d);
      return {d,body};
    };
    const estimate = document.createElement('div');
    estimate.className = 'wm-mobile-estimate';
    estimate.hidden = true;
    estimate.innerHTML = svg(icons.delivery);
    const estimateText = document.createElement('span');
    estimate.append(estimateText);
    module.prepend(estimate);
    const saving = document.createElement('span');
    saving.className = 'wm-mobile-saving';
    saving.hidden = true;
    const textMeasure = module.dataset.curtainSizes === 'true' ? document.createElement('canvas').getContext('2d') : null;
    const fittingSize = (node,width,maximum) => {
      if (!textMeasure || width <= 0) return maximum;
      const style = getComputedStyle(node);
      const text = node.textContent || '';
      textMeasure.font = `${style.fontWeight} ${maximum}px ${style.fontFamily}`;
      const measured = textMeasure.measureText(text).width;
      const spacing = (parseFloat(style.letterSpacing) || 0) * Math.max(0,text.length - 1);
      return measured ? Math.max(1,Math.floor(Math.min(maximum,maximum * (width - spacing - 1) / measured) * 4) / 4) : maximum;
    };
    const fitCurtainText = () => {
      if (!active || !textMeasure) return;
      info.querySelectorAll('.wm-curtain-select .wm-picker-trigger').forEach(trigger => {
        const text = trigger.querySelector('[data-wm-picker-value]');
        const arrow = trigger.querySelector('svg');
        if (!text) return;
        const style = getComputedStyle(trigger);
        const available = trigger.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight) - (arrow?.getBoundingClientRect().width || 0) - (parseFloat(style.columnGap) || 0);
        const size = fittingSize(text,available,64) + 'px';
        if (text.style.fontSize !== size) text.style.fontSize = size;
      });
      document.querySelectorAll('.wm-curtain-picker[open]').forEach(dialog => {
        const rows = [...dialog.querySelectorAll('.wm-picker-option')];
        const size = Math.min(64,...rows.map(row => {
          const text = row.querySelector('.wm-picker-option-words>span');
          const price = row.querySelector('.wm-picker-price');
          const meta = row.querySelector('.wm-picker-option-meta');
          const check = row.querySelector('.wm-picker-option-check');
          const style = getComputedStyle(row);
          const available = row.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight)
            - (check?.getBoundingClientRect().width || 0) - (parseFloat(style.columnGap) || 0)
            - (price && meta ? parseFloat(getComputedStyle(meta).columnGap) || 0 : 0);
          let measured = 0;
          let spacing = 0;
          [text,price].filter(Boolean).forEach(node => {
            const nodeStyle = getComputedStyle(node);
            const words = node.textContent || '';
            textMeasure.font = `${nodeStyle.fontWeight} 64px ${nodeStyle.fontFamily}`;
            measured += textMeasure.measureText(words).width;
            spacing += (parseFloat(nodeStyle.letterSpacing) || 0) * Math.max(0,words.length - 1);
          });
          return measured ? Math.max(1,Math.floor(Math.min(64,64 * (available - spacing - 1) / measured) * 4) / 4) : 64;
        })) + 'px';
        rows.forEach(row => {
          row.querySelectorAll('.wm-picker-option-words>span,.wm-picker-price').forEach(node => {
            if (node.style.fontSize !== size) node.style.fontSize = size;
          });
        });
      });
    };
    const timelineRoot = info.querySelector('#ss-delivery')?.parentElement;
    const update = () => {
      ensureInitialAvailableVariant();
      if (!active) return;
      const priceRoot = info.querySelector('.t4s-product__price-review .t4s-product-price');
      if (priceRoot && !priceRoot.contains(saving)) priceRoot.append(saving);
      const id = form?.querySelector('[name="id"]')?.value;
      const variant = variants.find(v => String(v.id) === String(id));
      const percent = variant?.compare_at_price > variant?.price ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
      saving.hidden = !percent;
      const text = `${labels.save} ${percent}%`;
      if (saving.textContent !== text) saving.textContent = text;
      info.querySelectorAll('.wm-has-mobile-select').forEach(group => {
        const select = group.querySelector('.wm-mobile-select-wrap select');
        const items = [...group.querySelectorAll('[data-swatch-item]')];
        const current = items.find(item => item.classList.contains('is--selected'))?.dataset.value;
        if (select && current && select.value !== current) select.value = current;
        const triggerText = group.querySelector('[data-wm-picker-value]');
        if (triggerText && triggerText.textContent !== select.value) triggerText.textContent = select.value;
        if (select) [...select.options].forEach(option => {
          const item = items.find(item => item.dataset.value === option.value);
          option.disabled = item?.classList.contains('is--unavailable') || false;
        });
      });
      const sku = information.querySelector('[data-wm-sku]');
      if (sku) sku.textContent = `${labels.sku}: ${variant?.sku || module.dataset.sku || ''}`;
      const timeline = timelineRoot?.querySelector('[id^="ss-delivery-body-"]');
      if (timeline) {
        timeline.classList.add('wm-native-delivery');
        const dateNodes = [...timeline.querySelectorAll('[class^="delivery-date-"]')];
        const date = dateNodes.at(-1)?.textContent.replace(/\s+/g,' ').trim();
        if (date) {
          const next = `${labels.estimated}: ${date}`;
          if (estimateText.textContent !== next) estimateText.textContent = next;
          estimate.hidden = false;
        }
      }
      const matches = module.querySelector('.wm-mobile-matches');
      if (matches) matches.hidden = !matches.querySelector('.wm-mobile-match');
      fitCurtainText();
    };
    const schedule = () => {
      if (!active || raf) return;
      raf = requestAnimationFrame(() => {raf = 0; update();});
    };
    const enable = () => {
      if (active) return;
      active = true;
      relocate(module,info);
      const brand = document.createElement('p');
      brand.className = 'wm-mobile-brand';
      brand.textContent = module.dataset.vendor;
      info.prepend(brand);
      cleanup.push(() => brand.remove());
      const backLink = module.querySelector('.wm-mobile-back-link');
      const nativeBreadcrumb = document.querySelector('.t4s-pr_breadcrumbs .t4s-pr-breadcrumb');
      if (backLink && nativeBreadcrumb) {
        try {
          const referrer = document.referrer ? new URL(document.referrer) : null;
          const match = referrer?.pathname.match(/^\/collections\/([^/]+)\/?$/);
          const collections = JSON.parse(module.querySelector('[data-wm-collections]').textContent);
          const known = match && collections.find(c => c.handle === decodeURIComponent(match[1]));
          if (referrer?.origin === location.origin && known) {
            backLink.href = referrer.href;
            backLink.querySelector('[data-wm-back-label]').textContent = labels.back_to.replace('[collection]',known.title);
          }
        } catch {}
        relocate(backLink,nativeBreadcrumb.parentElement);
        nativeBreadcrumb.classList.add('wm-native-breadcrumb');
        cleanup.push(() => nativeBreadcrumb.classList.remove('wm-native-breadcrumb'));
      }

      const wishlist = info.querySelector('.t4s-product-form__buttons .t4s-pr-wishlist');
      if (wishlist) relocate(wishlist,brand);
      if (originalTitle) {
        originalTitle.classList.add('wm-mobile-title');
        const vendor = module.dataset.vendor;
        if (vendor && titleText.toLowerCase().startsWith(vendor.toLowerCase() + ' ')) originalTitle.textContent = titleText.slice(vendor.length).trim();
        cleanup.push(() => {originalTitle.textContent = titleText;originalTitle.classList.remove('wm-mobile-title');});
      }
      const panels = [...root.querySelectorAll('.t4s-product-tabs-wrapper [data-t4s-tab-content]')].filter(panel => !panel.parentElement.closest('[data-t4s-tab-content]'));
      let description;
      let delivery;
      for (const panel of panels) {
        if (panel.querySelector('#judgeme_product_reviews,.jdgm-review-widget,ryviu-widget,#looxReviews')) continue;
        const wrapper = panel.closest('[data-t4s-tab-wrapper]');
        const label = wrapper?.querySelector('.t4s-tab__text')?.textContent.trim() || '';
        const isDescription = panel.id.startsWith('t4s-tab-des');
        const isDelivery = /delivery|returns|refund/i.test(label);
        const slot = isDelivery ? delivery ||= details(labels.delivery_returns,'delivery') : details(isDescription ? labels.details : label || labels.details,'details');
        if (isDescription) description = slot.body;
        if (isDelivery) {
          const heading = document.createElement('h3');heading.textContent = label;slot.body.append(heading);
        }
        [...panel.childNodes].forEach(node => relocate(node,slot.body));
        wrapper?.classList.add('wm-native-tab');
        cleanup.push(() => wrapper?.classList.remove('wm-native-tab'));
      }
      if (description) {
        const sku = document.createElement('p');sku.dataset.wmSku = '';sku.style.fontSize = '12px';description.append(sku);
        const careHeading = [...description.querySelectorAll('h2,h3,h4,h5')].find(h => /^care(?: instructions| guide)?\s*:?$/i.test(h.textContent.trim()));
        if (careHeading) {
          const level = Number(careHeading.tagName.slice(1));
          const nodes = [];
          let next = careHeading.nextSibling;
          while (next) {
            if (next.nodeType === 1 && /^H[1-6]$/.test(next.tagName) && Number(next.tagName.slice(1)) <= level) break;
            if (next.nodeType !== 1 || !next.hasAttribute('data-wm-sku')) nodes.push(next);next = next.nextSibling;
          }
          if (nodes.some(n => n.textContent.trim() || n.nodeType === 1 && n.querySelector?.('img'))) {
            const care = details(labels.care,'care');
            const deliveryDetails = delivery?.d;
            if (deliveryDetails) deliveryDetails.before(care.d);
            nodes.forEach(node => relocate(node,care.body));
            careHeading.hidden = true;
            cleanup.push(() => {careHeading.hidden = false;});
          }
        }
      }
      root.querySelectorAll('[data-t4s-tab-ul]').forEach(nav => {
        nav.classList.add('wm-native-tab-nav');cleanup.push(() => nav.classList.remove('wm-native-tab-nav'));
      });
      info.querySelectorAll('[data-swatch-option]:not(.is-t4s-style__color)').forEach((group,index) => {
        const items = [...group.querySelectorAll('[data-swatch-item]')];
        if (!items.length) return;
        const wrap = document.createElement('div');wrap.className = 'wm-mobile-select-wrap';
        const select = document.createElement('select');
        select.setAttribute('aria-label',group.querySelector('.t4s-swatch__title')?.textContent.split(':')[0].trim() || `Option ${index+1}`);
        const unique = [...new Set(items.map(item => item.dataset.value))];
        unique.forEach(value => select.add(new Option(value,value)));
        select.onchange = () => {
          allowInitialAvailabilityFix = false;
          const item = items.find(item => item.dataset.value === select.value);
          if (item && !item.classList.contains('is--unavailable')) item.click();
          schedule();
        };
        const optionName = select.getAttribute('aria-label');
        const pickerId = `wm-picker-${module.dataset.productId}-${index}`;
        const trigger = document.createElement('button');
        trigger.type = 'button';trigger.className = 'wm-picker-trigger';
        trigger.setAttribute('aria-haspopup','dialog');trigger.setAttribute('aria-controls',pickerId);
        trigger.setAttribute('aria-expanded','false');
        const triggerText = document.createElement('span');triggerText.dataset.wmPickerValue = '';
        trigger.append(triggerText);
        trigger.insertAdjacentHTML('beforeend',svg('<path d="m5 9 7 7 7-7"/>'));
        const dialog = document.createElement('dialog');
        dialog.id = pickerId;dialog.className = 'wm-mobile-picker-dialog';
        if (module.dataset.curtainSizes === 'true') {dialog.classList.add('wm-curtain-picker');wrap.classList.add('wm-curtain-select');}
        dialog.setAttribute('aria-labelledby',`${pickerId}-title`);
        const header = document.createElement('div');header.className = 'wm-picker-header';
        const heading = document.createElement('h2');heading.id = `${pickerId}-title`;heading.textContent = optionName;
        const close = document.createElement('button');close.type = 'button';close.className = 'wm-picker-close';
        close.setAttribute('aria-label',labels.close);close.innerHTML = svg('<path d="m6 6 12 12M18 6 6 18"/>');
        close.onclick = () => dialog.close();header.append(heading,close);
        const list = document.createElement('div');list.className = 'wm-picker-list';
        dialog.append(header,list);document.body.append(dialog);
        const populate = () => {
          list.replaceChildren();
          const optionIndex = Number(group.dataset.id ?? [...info.querySelectorAll('[data-swatch-option]')].indexOf(group));
          const selectedId = form?.querySelector('[name="id"]')?.value;
          const selectedVariant = variants.find(v => String(v.id) === String(selectedId)) || variants[0];
          const optionVariants = unique.map(value => variants.find(v =>
            v.options?.[optionIndex] === value &&
            v.options.every((option,i) => i === optionIndex || option === selectedVariant?.options?.[i])
          ));
          const showPrices = new Set(optionVariants.filter(Boolean).map(v => v.price)).size > 1;
          const currency = new Intl.NumberFormat(module.dataset.locale || document.documentElement.lang || 'en-GB',{
            style:'currency',currency:module.dataset.currency || 'GBP'
          });
          unique.forEach((value,valueIndex) => {
            const item = items.find(item => item.dataset.value === value);
            const unavailable = item?.classList.contains('is--unavailable') || false;
            const soldOut = item?.classList.contains('is--soldout') || item?.classList.contains('is--sold-out') || item?.classList.contains('is--sold_out') || false;
            const chosen = select.value === value;
            const button = document.createElement('button');button.type = 'button';button.className = 'wm-picker-option';
            button.disabled = unavailable;button.dataset.wmSoldOut = String(soldOut);button.setAttribute('aria-pressed',String(chosen));
            const words = document.createElement('span');words.className = 'wm-picker-option-words';
            const name = document.createElement('span');name.textContent = value;words.append(name);
            if (unavailable || soldOut) {const status = document.createElement('small');status.textContent = unavailable ? labels.unavailable : labels.sold_out;words.append(status);}
            button.append(words);
            const meta = document.createElement('span');meta.className = 'wm-picker-option-meta';
            const pricedVariant = optionVariants[valueIndex];
            if (showPrices && pricedVariant) {
              const price = document.createElement('span');price.className = 'wm-picker-price';
              if (pricedVariant.compare_at_price > pricedVariant.price) price.classList.add('wm-picker-price-sale');
              price.textContent = currency.format(pricedVariant.price / 100);meta.append(price);
            }
            const check = document.createElement('span');check.className = 'wm-picker-option-check';check.setAttribute('aria-hidden','true');
            if (chosen) check.innerHTML = svg('<path d="m5 12 4 4L19 6"/>');
            meta.append(check);button.append(meta);
            button.onclick = () => {select.value = value;select.onchange();triggerText.textContent = value;dialog.close();};
            list.append(button);
          });
        };
        trigger.onclick = () => {populate();dialog.showModal();trigger.setAttribute('aria-expanded','true');fitCurtainText();};
        dialog.addEventListener('close',() => {trigger.setAttribute('aria-expanded','false');if (active) trigger.focus({preventScroll:true});});
        dialog.addEventListener('click',event => {if (event.target !== dialog) return;const r = dialog.getBoundingClientRect();if (event.clientY < r.top || event.clientY > r.bottom || event.clientX < r.left || event.clientX > r.right) dialog.close();});
        wrap.append(select,trigger);group.append(wrap);group.classList.add('wm-has-mobile-select');
        cleanup.push(() => {if (dialog.open) dialog.close();dialog.remove();wrap.remove();group.classList.remove('wm-has-mobile-select');});
      });
      const reviewWidget = document.querySelector('#judgeme_product_reviews');
      const reviewSection = reviewWidget?.closest('.shopify-section');
      if (reviewSection && !root.contains(reviewSection)) {
        reviewSection.classList.add('wm-mobile-review-section');
        cleanup.push(() => reviewSection.classList.remove('wm-mobile-review-section'));
        const snippet = info.querySelector('.shopify-app-block:has(.jdgm-review-snippet-widget-v2)');
        if (snippet) {
          snippet.classList.add('wm-mobile-review-snippet');
          relocate(snippet,module);
          const matches = module.querySelector('.wm-mobile-matches');
          if (matches) matches.before(snippet);
          cleanup.push(() => snippet.classList.remove('wm-mobile-review-snippet'));
        }
      }
      document.body.classList.add('wm-mobile-active');
      update();
    };
    const disable = () => {
      if (!active) return;
      active = false;
      cancelAnimationFrame(raf);raf = 0;
      while (bank.length) {const [node,anchor] = bank.pop();anchor.replaceWith(node);}
      while (cleanup.length) cleanup.pop()();
      information.replaceChildren();
      saving.remove();
      timelineRoot?.querySelectorAll('.wm-native-delivery').forEach(n => n.classList.remove('wm-native-delivery'));
      document.body.classList.remove('wm-mobile-active');
    };
    const change = () => mq.matches ? enable() : disable();
    mq.addEventListener('change',change);
    if (textMeasure) {
      window.addEventListener('resize',schedule,{passive:true});
      document.fonts?.ready.then(schedule);
    }
    const observer = new MutationObserver(() => {ensureInitialAvailableVariant();schedule();});
    const price = info.querySelector('.t4s-product__price-review');
    if (price) observer.observe(price,{childList:true,subtree:true,characterData:true});
    const variantForm = info.querySelector('.t4s-product-form__variants');
    if (variantForm) observer.observe(variantForm,{childList:true,subtree:true,attributes:true,attributeFilter:['class','value','selected']});
    if (timelineRoot) observer.observe(timelineRoot,{childList:true,subtree:true,characterData:true});
    form?.addEventListener('change',schedule);
    change();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',start);
})();
